import { get } from './request'
import { serverApiUrl } from '../config/server';
export default async (cityID = 'CH010100') => {
    let url = `http://api.yytianqi.com/observe?city=${cityID}&key=v5909nmd8hscaskp`
    const res = await get(url);
    return res;
}